<template>
    <span>
        <router-link :to="'/identifications/'+object.id" tag="span" v-if="object.user.name">
            <img height="30" v-if="object.user.photo" :src="object.user.photo" style="float:left;margin-right: 5px;"/>
            <span>{{ object.user.name }}</span><br>
            <span>{{ $t('global.fromDate') }} {{ object.user.fromDate }}</span>
        </router-link>
        <span v-if="!object.user.name">
            {{ object.user }}
        </span>
    </span>
</template>

<script>
    export default {
        name: 'tablerowuserrenderer',
        props: ['object'],
        data: () => ({

        })
    }
</script>

<style lang="scss" scoped>

</style>
